import { AgGridReact } from 'ag-grid-react';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { sbaAxios } from '../utils/sbaAxios';
import { updateCustomSettings } from '../../config/apiConfig';
import { forwardRef } from 'react';
export const SBAAGgrid = (Column, row, FilterOp) => {
    const columns = Column;
    const rowDatas = row;
    const filterOp = FilterOp;

    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, filter: 'agTextColumnFilter', suppressMovable: true,
        flex: 1,resizable:true
    };
    const sideBar = {
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnFilter: true,
                    suppressColumnSelectAll: true,
                    suppressColumnExpandAll: true,
                },
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ],
        defaultToolPanel: null,
    };

    return (
        <AgGridReact
            columnDefs={columns}
            rowData={rowDatas}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={20}
            sideBar={filterOp ? sideBar : null}
            enableBrowserTooltips={true}
            suppressScrollOnNewData={true}
        >
        </AgGridReact>

    )
}
export const SBGrid = forwardRef((props,ref) => {
    const { row, column, componentID, gridStyle, filters, pageSize,isLoading, ...otherProps } = props;
    const [columnDef, setColumnDef] = useState(column);
    const [rowData, SetRowData] = useState(row);
    const [filter,setFilter]=useState(filters);
    const [isGridReady,setIsGridReady]=useState(false);
    const [isGridLoading,setIsGridLoading]=useState(isLoading)
    
    useEffect(() => {
        setColumnDef(column);
    }, [column]);
    useEffect(() => {
        if (filters) {
            setFilter(filters);
        }
    }, [filters]);
    useEffect(()=>{
        if(filter && ref.current &&  ref.current.api )
        {
            ref.current?.api?.setFilterModel(filter);
        }
    },[filter,ref,isGridReady]);
    useEffect(() => {
        SetRowData(row);
    }, [row]);
    useEffect(() => {
        setIsGridLoading(isLoading);
    }, [isLoading]);
    useEffect(()=>{
        if(isGridLoading)
        ref?.current?.api?.showLoadingOverlay();      
    },[isGridLoading])
    const onGridReady = () => {
        setIsGridReady(true);
    };
    const onColumnVisibleChange = (e) => {
        saveGridSetting();
    };
    const saveGridSetting = () => {
        if (ref.current) {
            const updatedColumnDefs = ref.current.columnApi.getColumnState();
            const updatedFilters = ref.current.api.getFilterModel();
            
            const newColumnDefs = columnDef.map((column) => {
                const isVisible = updatedColumnDefs.find((col) => col.colId === column.field)?.hide !== true;
                return { ...column, hide: !isVisible };
            });
            ref.current.api.setColumnDefs(newColumnDefs);

            const filterString=JSON.stringify(updatedFilters);
            const colString=JSON.stringify(updatedColumnDefs);
            const saveData = {
              "componentId": componentID,
              "componentUserSettingId": 0,
              "userId": 0,
              "CustomSettingsValue":colString,
              "CustomFilterValue": filterString,
              "isGrid": true
            };
            sbaAxios({ url: updateCustomSettings, method: 'post', data: saveData }).then(response => {
              console.log('grid Data Updated SuccessFully')
            }).catch(error => { console.log(error) });
            console.log('Column state saved');
        }
    };
    const onColumnPinned = () => {
        //doubt need to clarify
    };
    const onFilterChanged = () => {
        saveGridSetting();
    };
    const defaultColDef = {
        wrapHeaderText: true,
        autoHeaderHeight: true, resizable: true, sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',minWidth:100
    };
    const sideBar = {
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ],
        defaultToolPanel: null,
    };
    const onColumnResized = () => {
        //doubt pending
    };
    return (
        <div className="ag-theme-alpine" style={gridStyle}>
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDef}
                ref={ref}
                onColumnVisible={onColumnVisibleChange}
                onColumnPinned={onColumnPinned}
                onGridReady={onGridReady}
                onFilterChanged={onFilterChanged}
                sideBar={sideBar}
                defaultColDef={defaultColDef}
                onColumnResized={onColumnResized}
                pagination={true}
                paginationPageSize={pageSize}
                // enableBrowserTooltips={true}
                tooltipInteraction={true} 
                tooltipShowDelay={0}
                overlayLoadingTemplate={'<div class="Loader"><div id="loading"><div><span style="--i: 1;"></span><span style="--i: 2;"></span><span style="--i: 3;"></span><span style="--i: 4;"></span><span style="--i: 5;"></span><span style="--i: 6;"></span><span style="--i: 7;"></span><span style="--i: 8;"></span><span style="--i: 9;"></span><span style="--i: 10;"></span></div></div></div>'}
                {...otherProps}
            />
        </div>
    );
});

